module.exports = __webpack_public_path__ + "static/media/problem-definition.1fe264cd.png";